export const note = {
  Note: "노트",
  NewNote: "새 노트",
  NewNoteDesc: "새로운 노트를 시작합니다.",
  NewNoteSuccess: "새 노트가 생성되었습니다.",
  DeleteNote: "노트 삭제",
  DeleteNoteDesc: "노트를 삭제합니다.",
  DeleteNoteSuccess: "노트가 성공적으로 삭제되었습니다.",
  Project: "프로젝트",
  SelectProject: "프로젝트 선택",
  SelectProjectDesc: "노트를 사용하기 위해 프로젝트를 선택하세요.",
} as const;
